import { fmt } from "@/lib/api";
import { Check } from "lucide-react";

const ORDER = ["essential", "complete", "signature"];

export const PackageCards = ({ pricing, copy, recommended, selected, onSelect }) => {
  return (
    <div className="grid md:grid-cols-3 gap-6 md:gap-5 items-stretch">
      {ORDER.map((pkg) => {
        const p = pricing.packages[pkg];
        const isRec = pkg === recommended;
        const isSel = pkg === selected;
        return (
          <div
            key={pkg}
            data-testid={`package-card-${pkg}`}
            onClick={() => onSelect(pkg)}
            className={`relative flex flex-col cursor-pointer bg-white transition-transform duration-200 hover:-translate-y-1 ${
              isRec
                ? "border-2 border-[#c19a6b] shadow-[0_12px_40px_rgba(193,154,107,0.25)] md:scale-[1.03]"
                : "border border-gray-200 shadow-[0_8px_30px_rgba(0,0,0,0.04)]"
            } ${isSel ? "ring-2 ring-black ring-offset-2" : ""}`}
          >
            {isRec && (
              <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-[#c19a6b] text-white text-[10px] tracking-[0.25em] uppercase font-bold py-1.5 px-4 whitespace-nowrap" data-testid="most-popular-badge">
                Most Popular · ARK Recommended
              </div>
            )}
            <div className={`p-7 pb-5 ${isRec ? "pt-9" : ""}`}>
              <p className="text-[11px] uppercase tracking-[0.2em] text-gray-400 mb-1">ARK Furniture</p>
              <h3 className="font-display text-2xl">{p.label}</h3>
              <div className="mt-4 flex items-baseline gap-2">
                <span className="font-display text-4xl" data-testid={`package-price-${pkg}`}>{fmt(p.subtotal_cents)}</span>
                <span className="text-xs text-gray-400">+ HST</span>
              </div>
              <p className="text-sm text-gray-500 mt-3 leading-relaxed">{copy[`${pkg}_tagline`]}</p>
            </div>
            <div className="px-7 pb-7 flex-1 flex flex-col">
              {pkg !== "essential" && (
                <p className="text-[11px] uppercase tracking-[0.15em] text-[#c19a6b] font-bold mb-3">
                  Everything in {pkg === "complete" ? "Essential" : "Complete"} +
                </p>
              )}
              <ul className="space-y-2.5 flex-1">
                {copy[`${pkg}_includes`].map((inc, i) => (
                  <li key={i} className="flex gap-2.5 text-sm text-gray-700 leading-snug">
                    <Check size={15} className="text-[#c19a6b] shrink-0 mt-0.5" />
                    <span>{inc}</span>
                  </li>
                ))}
              </ul>
              <button
                data-testid={`select-package-${pkg}`}
                onClick={(e) => {
                  e.stopPropagation();
                  onSelect(pkg);
                }}
                className={`mt-7 w-full h-12 text-xs uppercase tracking-[0.18em] font-bold btn-lift ${
                  isSel
                    ? "bg-black text-white"
                    : isRec
                    ? "bg-[#c19a6b] text-white hover:bg-[#b08a5c]"
                    : "border-2 border-black text-black hover:bg-black hover:text-white"
                }`}
              >
                {isSel ? "Selected" : `Choose ${p.label.split(" ")[0]}`}
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};
